const cate = {
  "causal-cate-title": "CATE(Conditional ATE)",
  "causal-cate-outcome-node-label": "Select a target for analysis:",
  "causal-cate-outcome-node": "Outcome Node",
  "causal-cate-treatment-node-label": "Set the node to be treated (intervened):",
  "causal-cate-treatment-node": "Treatment Node",
  "causal-cate-outcome-distribution": "Distribution of Outcome Node",
  "causal-cate-treatment-distribution": "Distribution of Treatment Node",
  "causal-cate-treatment-histogram": "Histogram of Treatment Node",
  "causal-histogram-outlier-count": "(Outliers: {{num}})",
  // X-axis label for the CATE result chart (outcome name + "CATE of" + unit)
  "causal-cate-effect-axis-with-unit": "CATE of {{name}} ({{unit}})",
  "causal-cate-effect-axis-no-unit": "CATE of {{name}}",
  // Top title for the level-wise (stratified) chart
  "causal-cate-ite-level-distribution": "Distribution of Treatment Effects per {{name}} Level",
  "causal-cate-population-percentage-label": "% of ID Codes",
  "causal-cate-time-lag": "Time Lag",
  "causal-cate-check-nodes-label": "Check Nodes",
  "causal-cate-calculate-button": "Calculate CATE",
  "causal-cate-model-list-button": "Model List",
  "causal-cate-load-graph-button": "Load Existing Graph",
  "causal-cate-graph-list-title": "Select Graph",
  "causal-cate-graph-name-label": "Graph Name",
  "causal-cate-modifier-factors": "Covariates",
  "causal-cate-result-title": "CATE Analysis Results",
  "causal-cate-calculation-result": "CATE Calculation Result",
  "causal-cate-ite-options": "ITE Options",
  "causal-cate-model-id": "Model ID",
  "causal-cate-outcome": "Outcome",
  "causal-cate-treatment": "Treatment",
  "causal-cate-covariates": "Covariates",
  "causal-cate-available-options": "Available Options",
  "causal-cate-no-data": "No Data",
  "causal-cate-no-data-description": "Results will appear here after running CATE calculation",
  "causal-cate-edit-name-button": "Edit Name",
  "causal-cate-enter-name-label": "Please enter a name",
  "causal-cate-save-graph-button": "Save",
  "causal-cate-id-code-selection": "ID Code Selection",
  "causal-cate-date-selection": "Date Selection",
  "causal-cate-analysis-title": "CATE Result",
  "causal-cate-history-error": "Failed to load history",
  "causal-cate-no-history": "No model history",
  "causal-cate-model-name-label": "Model Name",
  "causal-cate-list-create-date": "Created Date",
  "causal-cate-confirm-button": "Confirm",
  "causal-cate-cancel-button": "Cancel",
  "causal-cate-rename": "Rename",
  "causal-cate-delete": "Delete",

  "strat-node": "Stratification Variable",

  // Toast messages
  "causal-cate-toast-delete-success": "Model deleted successfully",
  "causal-cate-toast-delete-error": "Failed to delete model",

  // Effect Prediction
  "causal-cate-effect-prediction": "Effect Prediction",
  "causal-cate-predict-button": "Predict",
  "causal-cate-estimated-effect": "Estimated Effect",
  "causal-cate-prediction-success": "Prediction completed successfully",
  "causal-cate-prediction-error": "Failed to predict effect",
  "causal-cate-no-model-error": "No model available for prediction",
  "causal-cate-no-covariates": "No covariates available for this user",

  // Conditional Effect Calculation
  "calculating": "Calculating...",
  "calculate-conditional-effect": "Calculate Effect",
  "error-noModelSelected": "No model selected",
  "error-noUserSelected": "No user selected",
  "success-calculated": "Calculation completed successfully",
  "error-calculationFailed": "Calculation failed",
  "cate-value-label": "Conditional ATE",
  "cate-value-near-zero-warning": "This value is near zero and may not have been calculated properly.",
  "causal-cate-average-label": "Average",
  "causal-cate-legend-label": "Distribution of Treatment Effects",
  "causal-cate-no-treatment-nodes": "This outcome has no valid treatment nodes. Please change the treatment node or change the model.",
  "causal-cate-ok-button": "OK",

  // Edit mode
  "edit": "Edit",
  "reset": "Reset",
  "search-id-codes": "Search ID Codes",

  // Binarize Treatment
  "cate-binarize-button": "Binarize Treatment",
  "cate-binarize-cancel": "Cancel Binarization",
  "cate-binarize-panel-title": "Binarization",
  "cate-binarize-threshold": "Threshold",
  "cate-binarize-level0": "Level 0",
  "cate-binarize-level1": "Level 1",
  "cate-binarize-sample-count": "Sample Count",
  "cate-binarize-min-samples": "All discretization levels must contain at least 10 samples.",
  "cate-binarize-confirm": "Confirm",
  "cate-binarize-no-data": "Select a threshold within the data range",

};

export default cate;